import { ellipsisStyle } from "@msys/ui";
import { Description as DescriptionIcon } from "@mui/icons-material";
import {
  Box,
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemProps,
  ListItemText,
} from "@mui/material";
import React from "react";

interface Props {
  file: {
    url: string;
    title: string;
  };
  secondaryAction?: React.ReactNode;
  titleBadge?: React.ReactNode;
}

export const FileListItemButton = ({
  file,
  secondaryAction,
  titleBadge,
  ...props
}: Props & ListItemProps) => {
  const button = (
    <ListItemButton
      dense
      component={Link}
      href={file.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
      }}
      style={ellipsisStyle}
      sx={titleBadge ? { flex: "0 1 auto", minWidth: 0 } : undefined}
    >
      <ListItemIcon
        sx={theme => ({
          minWidth: theme.layout.listItemMinWidth.xs,
          display: "flex",
          alignItems: "center",
        })}
      >
        <DescriptionIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText
        style={ellipsisStyle}
        primary={file.title}
        slotProps={{
          primary: { style: ellipsisStyle },
        }}
      />
    </ListItemButton>
  );

  return (
    <ListItem
      dense
      component="div"
      disablePadding
      secondaryAction={secondaryAction}
      {...props}
    >
      {titleBadge ? (
        // The badge sits beside the link, not inside it, so the row keeps a
        // single interactive target per control.
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            minWidth: 0,
            pr: secondaryAction ? 6 : 2,
          }}
        >
          {button}
          <Box sx={{ display: "flex", flexShrink: 0, ml: 1 }}>{titleBadge}</Box>
        </Box>
      ) : (
        button
      )}
    </ListItem>
  );
};
